import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { UserStorageContext } from 'context/UserStorageContext';

import Tooltip from 'components/tooltip';

import IconMinimize from 'icons/icon-minimize';

const TaskMinimize = ({ id, closeTask }) => {
    const { t } = useTranslation('task');
    const userStorage = useContext(UserStorageContext);

    const handleMinimize = () => {
        userStorage.saveMinimizedTask(id);
        closeTask();
    }

    useEffect(() => {
        userStorage.removeMinimizedTask(id);
    }, []);

    return (
        <Tooltip tooltip={t('Minimize task')}>
            <button className="content-panel-control btn content-panel-close" onClick={handleMinimize}><IconMinimize /></button>
        </Tooltip>
    )
}

export default TaskMinimize;
